<script>
    export default {
        data() {
            return {
                date: new Date(),
            }
        },
        methods: {},
        computed: {},
        mounted() {
            setInterval(() => {
                this.date = new Date();
            }, 10000)
        },
    }
</script>
<template>
    <div class="mag-header-date">
        Сейчас&nbsp;<span>{{date.toStringTime()}}</span>,&nbsp;{{date.getDate()}}&nbsp;{{date.toStringMonth()}}
    </div>
</template>
<style lang="scss">
    .mag-header-date {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 8px;
        font-size: 13px;
        span {
            color: #0a9088;
            font-weight: 700;
        }
    }
</style>